export function getUrlParams(query: string) {
  return query
    ? (/^[?#]/.test(query) ? query.slice(1) : query).split("&").reduce((params: any, param) => {
        let [key, value] = param.split("=");
        params[key] = value ? decodeURIComponent(value.replace(/\+/g, " ")) : "";
        return params;
      }, {})
    : {};
}

export function composePathWithParams(path: string, replacements: any[], absolute = false): string {
  let res = path;
  replacements.forEach((item) => {
    Object.keys(item).forEach(function (key) {
      res = res.replace(`:${key}`, item[key]);
    });
  });
  return `${absolute ? window.location.origin : ""}${res}`;
}

export function getYouTubeThumbFromUrl(youtubeUrl: string): string {
  var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
  var match = youtubeUrl.match(regExp);
  return match && match[7].length === 11 ? `http://i3.ytimg.com/vi/${match[7]}/hqdefault.jpg` : "";
}

export function getYouTubeIdFromUrl(youtubeUrl: string): string {
  return youtubeUrl;

  // try {
  //   let videoId = youtubeUrl.split("v=")[1];
  //   const ampersandPosition = videoId.indexOf("&");
  //   if (ampersandPosition !== -1) {
  //     videoId = videoId.substring(0, ampersandPosition);
  //   }
  //   return videoId;
  // } catch (err) {
  //   console.error(err);
  //   return "";
  // }
}

export function b64EncodeUnicode(str: string): string {
  // first we use encodeURIComponent to get percent-encoded UTF-8,
  // then we convert the percent encodings into raw bytes which
  // can be fed into btoa.
  return btoa(
    encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, function toSolidBytes(match, p1) {
      // @ts-ignore
      return String.fromCharCode("0x" + p1);
    })
  );
}
